import gsap from 'gsap';

export const show = e => {
    gsap.set(e, {
        autoAlpha: 1,
        pointerEvents: 'auto',
    })
}

export const animateShow = e => {
    gsap.to(e, {
        autoAlpha: 1,
        pointerEvents: 'auto',
        duration: 0.3
    })
}

export const logoShow = e => {
    if (e == 'index' && window.scrollY >= window.innerHeight ) {
        const tl = gsap.timeline();
        const logo = document.querySelector('.navbar__intro-logo');

        tl
        .to('.navbar__logo', {
            autoAlpha: 1,
            duration: 0.1,
        })
        .to(logo, {
            autoAlpha: 0,
            duration: 0.1,
            delay: 0.1
        })
    }
}
